import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {EventActivity, EventLog, EventLogActivity, EventLogParam} from './event-log.model';
import {EventLogApiQuery} from './event-log-api-query';
import {Dashboard} from '../dashboard/dashboard.model';
import {ReactiveService} from '../reactive-service.abstract';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';
import {mergeMap} from 'rxjs/operators';
import _ from 'lodash';
import {isArray} from 'util';

export const MAX_QUERY_LENGTH = 500;

@Injectable()
export class EventLogApiService extends ReactiveService {
  private baseUrl = environment.backEndUrlPrefix + '/' + `v2/eventlog`; /* Меню- Файлы журнала - Журнал событий*/
  private baseV1Url = environment.backEndUrlPrefix + '/' + `db/eventlog`;

  constructor(private http: HttpClient) {
    super();
  }

  public getLog(params: EventLogApiQuery): Observable<EventLog[]> {
    const body = Object.keys(params).reduce((acc, key) => {
      const value = params[key];
      if (value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0)) {
        acc[key] = value;
      }
      return acc;
    }, {} as any);
    return this.http.post<EventLog[]>(this.baseUrl, body);
  }


  public _getLog(params: EventLogApiQuery): Observable<EventLog[]> {

    const queryParams: { [param: string]: string | string[] } = Object.assign({},
      ...Object.keys(params)
        .filter(key => params[key] !== undefined)
        .map(key => ({[key]: params[key]}))
    );
    if (queryParams.event) {
      delete Object.assign(queryParams, {['eventid']: queryParams['event']})['event'];
    }
    return this.http.get<EventLog[]>(this.baseUrl, {
      params: queryParams
    });
  }

  public getLogById(id: string|number): Observable<EventLog> {
    return this.http.get<EventLog>(`${this.baseV1Url}/${id}`);
  }
  /* Меню -> Журнал событий */
  public getLogActivity(params: EventLogApiQuery): Observable<EventLogActivity[] | any> {
    const queryParams: { [param: string]: string | string[] } = Object.assign({},
      ...Object.keys(params)
        .filter(key => params[key] !== undefined)
        .map(key => ({[key]: params[key]}))
    );
    if (queryParams && queryParams.unit && queryParams.unit.length > MAX_QUERY_LENGTH) {
      const reqs =  [];
      const maxLength = Math.ceil(queryParams.unit.length / MAX_QUERY_LENGTH);
      const units = queryParams.unit;
      delete queryParams.unit;
      for (let i = 0; i < maxLength; i++) {
        const q = _.cloneDeep(queryParams);
        q.unit = units.slice(MAX_QUERY_LENGTH * i, MAX_QUERY_LENGTH * (i + 1));
        reqs.push(this.http.get<EventLogActivity[]>(environment.backEndUrlPrefix + `/v2/eventlog`,  {params: q}));
      }
      return forkJoin(reqs).pipe(
        mergeMap ( data => {
          const ret = [];
          if (data && isArray(data)) {
            data.forEach(dat => {
              (dat as any).forEach(d => {
                ret.push(d);
              });
            });
          }
          const observable = new Observable((observer) => {
            observer.next(ret);
            observer.complete();
          });
          return observable;
        })
      );

    } else {
      return this.http.get<EventLogActivity[]>(environment.backEndUrlPrefix + `/v2/eventlog`, {
        params: queryParams
      });
    }

  }


  public getDashboard(idEvent) {
    return this.http.get<Dashboard[]>(`/db/eventlog/${idEvent}/dashboard`);
  }

  public getMessages(id): Observable<EventActivity[]> {
    return this.http.get<EventActivity[]>(`/db/eventlog/${id}/activity`);
  }

  public getParam(id): Observable<EventLogParam> {
    return this.http.get<EventLogParam>(`/db/eventlog/${id}/param`);
  }

  public addMessage(id, message): Observable<EventActivity> {
    return this.http.post<EventActivity>(`/db/eventlog/${id}/activity`, message);
  }

  public addMessages(id: string[], message): Observable<EventActivity> {
    return this.http.post<EventActivity>(`/db/eventlog/mark`, null, {params: {id: id, message: message}});
  }


  public getById(id): Observable<EventLogActivity> {
    return this.http.get<EventLogActivity>(`/db/eventlog/${id}`);
  }
}
